import SocketFactory from '@/drivers/socket'

import type { PrinterConfig, PrinterDriver } from '../types'
import StarGraphicEncoder from './star-graphic-encoder'

export default class StarGraphic implements PrinterDriver {
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    this.config = config
  }

  printImage(canvas: HTMLCanvasElement) {
    return new Promise<void>((resolve, reject) => {
      const rejectMiddleware = (error: unknown) => {
        reject(error)
      }
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.ip,
        9100,
        async () => {
          const width = 576
          const ratio = width / canvas.width
          const height = Math.round((canvas.height * ratio) / 8) * 8

          const encoder = new StarGraphicEncoder()
          const result = encoder.initialize().image(canvas, width, height).cut().encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, rejectMiddleware)
            },
            rejectMiddleware
          )
        },
        rejectMiddleware
      )
    })
  }

  openCashDrawer() {
    return new Promise<void>((resolve, reject) => {
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.ip,
        9100,
        () => {
          const encoder = new StarGraphicEncoder()
          const result = encoder.initialize().openCashDrawer().encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, reject)
            },
            reject
          )
        },
        reject
      )
    })
  }
}
